import './BetbookPostEditorWizard.less';
import clsx from 'clsx';
import React from 'react';
import i18n from '../../../common/i18n';
import { replacePlaceholdersInString } from '../utils/replacePlaceholdersInString';
import BetbookPostEditorBet from './BetbookPostEditorBet';
import BetbookTicket from '../betbookTicket/BetbookTicket';
import moment from 'moment';
import { isProfBetbookRewardsShowInfoEnabled } from '../../../profiles';

const BetbookPostEditorWizard = ({
    step,
    setTitle,
    selectedBet,
    setSelectedBet,
    selectedTicket,
    openTicketDetail,
    setSelectedTicket,
    marketingAgreement,
    gamingOpportunities,
    analysesLimitReached,
    canHaveAnalysisReward,
    gamingOpportunityTickets
}) => {
    const componentReplaceMap = {
        '{0}': () => <strong className="c-black-50 fs-13">1,25</strong>,
        '{1}': () => <strong className="c-black-50 fs-13">1&euro;</strong>
    };
    const dateToShowInfo = '1.6.2023';

    const remainingLimitTime = analysesLimitReached
        ? moment(analysesLimitReached.firstPostInInterval).add(analysesLimitReached.limits.maxAnalysesIntervalDays, 'd')
        : null;

    const dayOrDays =
        analysesLimitReached && analysesLimitReached.limits.maxAnalysesIntervalDays === 1
            ? i18n('day.one')
            : i18n('day.many');

    const filteredBet = gamingOpportunities?.find(bet => bet.betId === selectedBet?.betId);
    const filteredTicket = gamingOpportunityTickets?.find(ticket => ticket.ticketId === selectedTicket);

    let wizardTitle;
    if (step === 1) {
        if (gamingOpportunities?.length) {
            wizardTitle = i18n('nui.betbook.select-bet');
        } else {
            wizardTitle = i18n('nui.betbook.not-available-bets');
        }
    } else if (step >= 2) {
        wizardTitle = i18n('nui.betbook.analysed-tip');
    }

    return (
        <>
            {(marketingAgreement === 0 && step === 1) || analysesLimitReached || !canHaveAnalysisReward ? (
                <span className="betbook-analyse-warning text-center">
                    {marketingAgreement === 0 ? (
                        <p>
                            {i18n('nui.betbook.gdpr.warning') + ' '}
                            <a href={'/osobna-zona/moj-profil'}>{i18n('nui.betbook.gdpr.change.settings')}</a>
                        </p>
                    ) : analysesLimitReached && analysesLimitReached.limitReached ? (
                        <p>
                            {i18n(
                                'nui.betbook.limit.reach.warning',
                                analysesLimitReached.limits.maxAnalysesLimit,
                                analysesLimitReached.limits.maxAnalysesIntervalDays + ' ' + dayOrDays,
                                remainingLimitTime.format('D. M. YYYY'),
                                remainingLimitTime.format('hh:mm')
                            )}
                        </p>
                    ) : canHaveAnalysisReward === false ? (
                        <p>{i18n('nui.betbook.year.limit.reach.warning')}</p>
                    ) : null}
                </span>
            ) : null}

            <p
                className={clsx('fs-14 text-extra-bold my-10', {
                    'text-center': step === 1,
                    'text-left': step !== 1
                })}
            >
                {wizardTitle}
            </p>
            {step === 1 ? (
                <p className={clsx('fs-13 c-black-50 text-center lh-1-5', { 'mb-15': gamingOpportunities?.length })}>
                    {replacePlaceholdersInString(i18n('nui.betbook.post-add-instruction'), componentReplaceMap)}
                </p>
            ) : null}
            {isProfBetbookRewardsShowInfoEnabled() && step === 1 ? (
                <p
                    className={clsx('fs-13 mt-10 mb-15 c-black-50 text-center lh-1-5')}
                    dangerouslySetInnerHTML={{ __html: i18n('nui.prof.betbook.rewards.show.info', dateToShowInfo) }}
                />
            ) : null}
            {step === 1 && gamingOpportunities?.length
                ? gamingOpportunities.map((bet, i) => (
                      <BetbookPostEditorBet
                          key={i}
                          bet={bet}
                          step={step}
                          setTitle={setTitle}
                          selectedBet={selectedBet}
                          setSelectedBet={setSelectedBet}
                      />
                  ))
                : null}
            {step >= 2 ? <BetbookPostEditorBet step={step} bet={filteredBet || selectedBet} /> : null}
            {step === 2 ? (
                <p className="fs-14 text-extra-bold mb-10 mt-20">{i18n('nui.betbook.select-ticket')}</p>
            ) : null}
            {step === 2 && gamingOpportunityTickets?.length
                ? gamingOpportunityTickets.map((ticket, i) => (
                      <BetbookTicket
                          key={i}
                          selectable={step === 2}
                          ticket={ticket}
                          oldTicket={false}
                          showHeader
                          showBetCount
                          selectedTicket={selectedTicket}
                          openTicketDetail={openTicketDetail}
                          setSelectedTicket={setSelectedTicket}
                      />
                  ))
                : null}
            {step === 3 && selectedTicket ? (
                <BetbookTicket
                    selectable={step === 2}
                    showHeader
                    showBetCount
                    oldTicket={false}
                    ticket={filteredTicket || selectedTicket}
                    openTicketDetail={openTicketDetail}
                />
            ) : null}
        </>
    );
};

export default BetbookPostEditorWizard;
